import { render, staticRenderFns } from "./ExtraForm.vue?vue&type=template&id=56457812&scoped=true"
import script from "./ExtraForm.vue?vue&type=script&lang=js"
export * from "./ExtraForm.vue?vue&type=script&lang=js"
import style0 from "./ExtraForm.vue?vue&type=style&index=0&id=56457812&prod&lang=less&scoped=true"
import style1 from "./ExtraForm.vue?vue&type=style&index=1&id=56457812&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56457812",
  null
  
)

export default component.exports